import { request } from '@synergy/api';

import { Account } from '../models/account';
import { BaseState } from './models/base-state';
import { User } from '../models/user';

export class CommonApi {
    constructor(protected baseUrl: string) {}

    public async getBaseState(): Promise<BaseState | null> {
        const response = await request.get(`${this.baseUrl}/`);

        if (!response) {
            return null;
        }

        const account = response.data.currentAccount;
        const lastCheckedDate = account.lastCheckedDate && new Date(account.lastCheckedDate);
        const lastCheckedExpirationThresholdInDays = response.data.lastCheckedExpirationThresholdInDays;

        let accountNeedsToBeChecked = false;

        if (lastCheckedExpirationThresholdInDays) {
            // get the next check date with current date - threshold from backend
            const nextCheckDate = new Date();
            nextCheckDate.setDate(nextCheckDate.getDate() - lastCheckedExpirationThresholdInDays);

            // getTime() to check dates if different formats occur
            if (!lastCheckedDate || lastCheckedDate.getTime() < nextCheckDate.getTime()) {
                accountNeedsToBeChecked = true;
            }
        }

        return {
            currentAccount: {
                ...Account.fromPlainObject(response.data.currentAccount),
                lastCheckedDate,
                lastCheckedExpirationThresholdInDays,
                accountNeedsToBeChecked,
                requestingAccount: false,
            },
            currentAccountBonus: response.data.currentAccountBonus,
            locale: response.data.locale,
            user: User.fromPlainObject(response.data.user),
            lastCheckedExpirationThresholdInDays: response.data.lastCheckedExpirationThresholdInDays,
            settings: {
                currency: response.data.currency,
                mediaBaseUrl: response.data.mediaBaseUrl,
                isImpersonator: response.data.isImpersonator,
                privateFilesystemPath: `${response.data.apiBaseUrl}${response.data.privateFilesystemPath}`,
            },
        };
    }
}
